import React from 'react';
import { Box, Typography, IconButton, Modal, List, ListItem, ListItemText, Button, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const NotificationModal = ({ open, onClose, notifications, onClearNotification, onClearAllNotifications }) => {
  // Function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  };

  // Group notifications by agency
  const groupedNotifications = notifications.reduce((acc, notification) => {
    const { agencyName, agencyID } = notification;

    // Ensure agencyName and agencyID are present
    if (agencyName && agencyID) {
      const agencyKey = `${agencyName} (${agencyID})`; // Add agency ID in parentheses
      if (!acc[agencyKey]) {
        acc[agencyKey] = [];
      }
      acc[agencyKey].push(notification);
    }

    return acc;
  }, {});

  const formatMessageParts = (message) => {
    if (!message) return null;
  
    const keywords = ['Accepted', 'Declined', 'posted', 'Cancelled', 'expired'];
  
    const words = message.split(/(\s+)/);
  
    return words.map((word, idx) => {
      const cleanWord = word.replace(/[^\w]/g, ''); 
      if (keywords.includes(cleanWord)) {
        return <strong key={idx}>{word}</strong>;
      }
      return word;
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 700, maxHeight: '80vh', bgcolor: 'background.paper', boxShadow: 24, p: 4, overflowY: 'auto' }}>
        <Typography variant="h6" align="center" sx={{ mb: 2 }}>My Notifications</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>

        {notifications.length > 0 ? (
          Object.keys(groupedNotifications).map((agencyKey) => (
            <Box key={agencyKey} sx={{ mb: 4 }}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>{agencyKey}</Typography> {/* Bold agency name */}
              <List>
              {groupedNotifications[agencyKey].map((notification) => (
                <React.Fragment key={notification.notificationID}>
                  <ListItem 
                    sx={{ 
                      border: '2px solid #ccc', 
                      borderRadius: 2, 
                      mb: 2,
                      backgroundColor: '#f7f7f7',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      p: 2
                    }}
                  >
                    <Box sx={{ width: '100%' }}>
                      
                      <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '1rem', mb: 1 }}>
                        (Ref# {notification.keyValue}) Follow-up
                      </Typography>

                      
                      <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                        <strong>Status:</strong> {notification.notificationTypeName}<br />
                        <strong>Time:</strong> {formatDate(notification.createdAt)}<br />
                        <strong>Details:</strong>{' '}
                        {formatMessageParts(notification.message)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 2 }}>
                      <Button variant="contained" color="secondary" onClick={() => onClearNotification(notification.notificationID)} sx={{ minWidth: '100px' }}>
                        Clear
                      </Button>
                    </Box>
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))}
              </List>
            </Box>
          ))
        ) : (
          <Typography variant="body1" align="center" sx={{ mt: 4 }}>
            You have no new notifications at this time.
          </Typography>
        )}
        {notifications.length > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button variant="contained" color="secondary" sx={{ minWidth: '150px' }} onClick={onClearAllNotifications}>
              Clear All
            </Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default NotificationModal;
